import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import { SUBSCRIPTION_DETAILS_SLOT_COMPONENT_ID, SUBSCRIPTION_DETAILS_SLOT_ID } from './constants';

type ISettingsParams = {
  [SUBSCRIPTION_DETAILS_SLOT_ID]: SettingsParamType.Object;
  pageTitleText: SettingsParamType.Text;
  pageDescriptionText: SettingsParamType.Text;
  noSubscriptionText: SettingsParamType.Text;
  buyNewPlanText: SettingsParamType.Text;
  cancelSubscriptionText: SettingsParamType.Text;
  pricingPlansLinkText: SettingsParamType.Text;
  storesLinkText: SettingsParamType.Text;
  noSubscriptionTitle: SettingsParamType.Text;
};

const slotContainerMetadata: object = {
  metadata: {
    type: 'container',
    defaultValue: { type: 'static', value: {} },
    dataItemManifestData: {
      container: {
        containerType: 'slot',
        slot: { slotId: SUBSCRIPTION_DETAILS_SLOT_COMPONENT_ID },
      },
    },
  },
};

export default createSettingsParams<ISettingsParams>({
  [SUBSCRIPTION_DETAILS_SLOT_ID]: {
    type: SettingsParamType.Object,
    getDefaultValue: () => null as any,
    ...slotContainerMetadata,
  },
  pageTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-page-title-text'),
  },
  pageDescriptionText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-page-description-text'),
  },
  noSubscriptionText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-no-subscription-text'),
  },
  buyNewPlanText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-buy-new-plan-text'),
  },
  cancelSubscriptionText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-cancel-subscription-text'),
  },
  pricingPlansLinkText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-pricing-plans-text'),
  },
  storesLinkText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-stores-link-text'),
  },
  noSubscriptionTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.default-no-subscription-title'),
  },
});
